<template>
  <div>
    <div v-if="etat.horsLigne" class="alert alert-warning mb-0 rounded-0 py-2 px-3 d-flex align-items-center gap-2 flex-wrap" role="alert">
      <i class="bi bi-wifi-off fs-5"></i>
      <span>
        <strong>Pas de connexion au serveur</strong>{{ depuis ? ` depuis ${depuis}` : '' }}.
        <template v-if="etat.copieAffichee"> Affichage de la dernière copie ({{ heure(etat.copieAffichee) }}).</template>
        Les enregistrements habituels sont impossibles pour le moment.
      </span>
      <router-link v-if="peutAccueillir" to="/accueil-hors-ligne" class="btn btn-sm btn-dark ms-auto"><i class="bi bi-journal-plus me-1"></i>Accueil hors connexion</router-link>
    </div>
    <div v-else-if="etat.envoiEnCours" class="alert alert-info mb-0 rounded-0 py-2 px-3 d-flex align-items-center gap-2" role="status">
      <span class="spinner-border spinner-border-sm"></span>
      <span>Connexion rétablie : envoi des saisies faites hors connexion…</span>
    </div>
    <div v-else-if="etat.enAttente || etat.enErreur" class="alert mb-0 rounded-0 py-2 px-3 d-flex align-items-center gap-2 flex-wrap" :class="etat.enErreur ? 'alert-danger' : 'alert-info'" role="status">
      <i class="bi fs-5" :class="etat.enErreur ? 'bi-exclamation-octagon' : 'bi-cloud-upload'"></i>
      <span v-if="etat.enAttente">{{ etat.enAttente }} saisie(s) hors connexion en attente d'envoi.</span>
      <span v-if="etat.enErreur">{{ etat.enErreur }} saisie(s) hors connexion refusée(s) par le serveur : à vérifier.</span>
      <router-link to="/accueil-hors-ligne" class="btn btn-sm btn-outline-dark ms-auto">Voir</router-link>
    </div>
  </div>
</template>

<script>
import { etat } from '@/horsLigne/etat'
import { peutTravaillerHorsLigne } from '@/horsLigne/reference'

export default {
  name: 'BandeauConnexion',
  data() {
    return { etat }
  },
  computed: {
    depuis() {
      return etat.depuis ? this.heure(etat.depuis) : ''
    },
    peutAccueillir() {
      return peutTravaillerHorsLigne()
    },
  },
  methods: {
    heure(d) {
      const x = new Date(d)
      const aujourdhui = new Date().toDateString() === x.toDateString()
      const h = x.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
      return aujourdhui ? h : `${x.toLocaleDateString('fr-FR')} ${h}`
    },
  },
}
</script>
